<template>
  <div class="selectLinkman">
    <el-tooltip class="item" effect="light" :disabled="(userName ? false : true)" :content="userName" placement="top"
      :style="{width: myWidth}">
      <el-autocomplete highlight-first-item class="inline-input" v-model="userName" :readonly="inputDis" :size="size" :fetch-suggestions="querySearch"
        placeholder="请选择联系人" clearable @clear="reset" :trigger-on-focus="false" @select="handleSelect">
        <!-- <el-button slot="append" icon="el-icon-close" @click="reset"></el-button>
        <el-button slot="append" icon="el-icon-plus" :disabled="addBtn" @click="alertDialog"></el-button>-->
      </el-autocomplete>
    </el-tooltip>
    <el-dialog title="请选择联系人" :visible.sync="dialogVisible" append-to-body width="800px" :before-close="handleClose"
      :show-close="false">
      <el-input v-model="search" placeholder="请输入内容"></el-input>
      <el-table @current-change="handleCurrentChange" ref="multipleTable" :highlight-current-row="isHighlight" :data="tables"
        tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" @cell-dblclick="ondblclick"
        v-scrollBar:tableArg height="280px" v-loading="loading2">
        <el-table-column :type="whether" width="55"></el-table-column>
        <el-table-column label="联系人" width="200">
          <template slot-scope="scope">{{ scope.row.NAME }}</template>
        </el-table-column>
        <el-table-column prop="PHONE" label="电话" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ID" label="工号"></el-table-column>
        <el-table-column prop="GRADE" label="重要级别"></el-table-column>
      </el-table>
      <div style="text-align: center;">
        <el-button @click="toClose">关闭</el-button>
        <el-button type="primary" @click="toSure">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    GetSAllLinkmanList,
    listToTree
  } from "@/api/modules/basicData/location";
  export default {
    name: "selectLinkman",
    data() {
      return {
        dialogVisible: false,
        search: "",
        tableData: [],
        multipleSelection: [],
        allLinkData: [],
        loading2: false,
        whether: "selection",
        isHighlight: false,
        myWidth: "",
        loading: false,
        userName: "",
        inputDis: false,
        addBtn: false,
        radioRowData: null
      };
    },
    props: {
      isRadio: Boolean,
      setWidth: {
        type: String,
        default: ""
      },
      isValidateMethod: {
        type: Boolean,
        default: false
      },
      size: {
        type: String,
        default: ""
      },
      userNameString: {
        type: String,
        default: "normal" //  normal
      }
    },
    created() {
      if (this.isRadio == true) {
        this.whether = "index";
        this.isHighlight = true;
      }
      this.myWidth = this.setWidth;
    },
    mounted() {},
    computed: {
      tables() {
        const search = this.search;
        if (search) {
          return this.allLinkData.filter(dataNews => {
            return Object.keys(dataNews).some(key => {
              return (
                String(dataNews[key])
                .toLowerCase()
                .indexOf(search) > -1
              );
            });
          });
        }
        return this.tableData;
      }
    },
    methods: {
      GetData() {
        return new Promise((resolve, reject) => {
          GetSAllLinkmanList("super").then(res => {
            this.allLinkData = res;
            this.tableData = res.slice(0, 250);
            this.loading2 = false;
            resolve();
          });
        });
      },
      initDefaultLink(contactId) {
        // 初始化设置一个默认的联系人
        if (!this.allLinkData.length) {
          this.GetData().then(() => {
            this.setDefaultLink(contactId);
          });
        } else {
          this.setDefaultLink(contactId);
        }
      },
      setDefaultLink(contactId) {
        var defaultLink = this.allLinkData.filter(a => {
          return a.ID == contactId;
        });
        this.ondblclick(defaultLink[0]);
      },
      handleCurrentChange(row) {
        // 点击单行
        this.radioRowData = row;
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        console.log(val);
      },
      click() {
        this.dialogVisible = true;
        this.loading2 = true;
      },
      ondblclick(row, column, cell, event) {
        if (this.isRadio) {
          if (!row || !row.ID) {
            this.userName = "";
            return false;
          }
          if (this.userNameString == "report") {
            this.userName =
              this.isNull(row.NAME) +
              "," +
              this.isNull(row.PHONE) +
              "," +
              this.isNull(row.POST) +
              "," +
              this.isNull(row.GRADE) +
              "(重要级别)";
          } else {
            this.userName = row.NAME + "," + row.PHONE + "," + row.ID;
          }
          this.$emit("getValue", row);
          this.dialogVisible = false;
        }
      },
      isNull(n) {
        return n ? n : "";
      },
      querySearch(val, cb) {
        //提示搜索
        const PinyinMatch = require('pinyin-match');
        // console.error("01", this.allLinkData)
        var list = this.allLinkData.filter(a => {
          return (
            PinyinMatch.match((a.NAME || ""), val) != false ||
            (a.PHONE || "").indexOf(val) > -1 ||
            (a.PY || "").indexOf(val) > -1 ||
            (a.WB || "").indexOf(val) > -1
          );
        });
        console.error("01", list.map(a => {
          return Object.assign(a, {
            value: this.isNull(a.NAME) + " " + this.isNull(a.PHONE)
          });
        }))
        cb(
          list.map(a => {
            return Object.assign(a, {
              value: this.isNull(a.NAME) + " " + this.isNull(a.PHONE)
            });
          })
        );
      },
      handleSelect(row) {
        //提示搜索下的选择
        if (!row && !row.ID) {
          this.userName = "";
          return false;
        }
        if (this.userNameString == "report") {
          this.userName =
            this.isNull(row.NAME) +
            "," +
            this.isNull(row.PHONE) +
            "," +
            this.isNull(row.POST) +
            "," +
            this.isNull(row.GRADE) +
            "(重要级别)";
        } else {
          this.userName = row.NAME + "," + row.PHONE + "," + row.ID;
        }
        this.$emit("getValue", row);
      },
      reset() {
        //叉叉
        this.inputDis = false;
        this.userName = "";
      },
      alertDialog() {
        //点击弹出
        this.dialogVisible = true;
        if (!this.allLinkData.length) {
          this.GetData();
        }
      },
      handleClose(done) {
        //弹出框消失前执行
        this.dialogVisible = false;
      },
      toClose() {
        //取消
        this.dialogVisible = false;
      },
      toSure() {
        //确定
        this.userName = "";
        if (this.isRadio) {
          this.ondblclick(this.radioRowData);
          return false;
        }
        this.dialogVisible = false;
        if (this.multipleSelection.length > 0) {
          let isValidate = true; //判断验证是否通过
          if (this.isValidateMethod) {
            //判断是否需要验证
            this.$emit("toValidate", this.multipleSelection, function(str) {
              isValidate = str;
            });
            if (isValidate) {
              this.assignmentInput();
            }
          } else {
            this.$emit("getValue", this.multipleSelection);
            this.assignmentInput();
          }
        }
      },
      assignmentInput() {
        //input框赋值
        console.log(666);
        this.multipleSelection.forEach(c => {
          if (c.NAME == null) {
            c.NAME = "";
          }
          this.userName += c.NAME + "," + c.PHONE + "," + c.ID + "--";
        });
        this.userName = this.userName.substring(
          0,
          this.userName.lastIndexOf("--")
        );
        if (this.userName != "") {
          this.inputDis = true;
        }
      },

      uniqueArray(array, key) {
        var result = [array[0]];
        for (var i = 1; i < array.length; i++) {
          var item = array[i];
          var repeat = false;
          for (var j = 0; j < result.length; j++) {
            if (item[key] == result[j][key]) {
              repeat = true;
              break;
            }
          }
          if (!repeat) {
            result.push(item);
          }
        }
        return result;
      }
    }
  };
</script>

<style scoped>
</style>
